import React from "react";
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'


export const GaTracking = (props: any): JSX.Element => {

  if(process.env.APP_ENV != 'production') return null;

  React.useEffect(() => {
    ReactGA.initialize('G-QDNQG854E4');
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  React.useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-T4WZW83'
    }

    TagManager.initialize(tagManagerArgs)
  }, []);
  return null;
}